module.exports = __webpack_public_path__ + "static/media/error_red_exclamation.d4cc6f7e.svg";